import {
  Callout,
  Caption,
  Cite,
  Heading,
  Pullquote,
  Strong,
  Small,
  StatLabel,
} from "./styles"

const HeadingTwo = Heading.withComponent("h2")
const HeadingThree = Heading.withComponent("h3")
const HeadingFour = Heading.withComponent("h4")
const HeadingFive = Heading.withComponent("h5")
const HeadingSix = Heading.withComponent("h6")

const BlockQuote = Caption.withComponent("blockquote")

export {
  BlockQuote,
  Callout,
  Caption,
  Cite,
  Heading,
  HeadingTwo,
  HeadingThree,
  HeadingFour,
  HeadingFive,
  HeadingSix,
  Pullquote,
  Strong,
  Small,
  StatLabel,
}
